/**
 * Human-readable size similar to WhatsApp (e.g. "80 kB", "16 MB").
 */
export function formatHumanMediaBytes(bytes) {
  if (bytes == null || !Number.isFinite(Number(bytes)) || Number(bytes) < 0) return "";
  const n = Math.floor(Number(bytes));
  if (n < 1024) return `${n} B`;
  const kb = n / 1024;
  if (kb < 1024) {
    const rounded = kb < 10 ? Math.round(kb * 10) / 10 : Math.round(kb);
    return `${rounded} kB`;
  }
  const mb = kb / 1024;
  const roundedMb = mb < 10 ? Math.round(mb * 10) / 10 : Math.round(mb);
  return `${roundedMb} MB`;
}
